import React from 'react';
import { Div, Icon } from '@pinpoint/design-kit';
import PropTypes from 'prop-types';
import Button from 'src/components/button';

export function AirButtonGroup({ selected, handleSelection, classifier }) {
  return (
    <Div d="flex" align="flex-start" p={{ t: classifier ? '0' : '1rem' }}>
      <Button
        disabled={selected === 0}
        buttonStyle="admin"
        textWeight="600"
        textSize="body"
        onClick={() => handleSelection(0)}
      >
        <Icon viewBox="0 0 36 36" name="FairnessRace" color="white" m={{ r: '0.5rem' }} size="1rem" />
        RACE
      </Button>
      <Button
        disabled={selected === 1}
        buttonStyle="admin"
        textWeight="600"
        textSize="body"
        onClick={() => handleSelection(1)}
      >
        <Icon viewBox="0 0 36 33" name="FairnessSex" color="white" m={{ r: '0.5rem' }} size="1rem" />
        SEX
      </Button>
      <Button
        disabled={selected === 2}
        buttonStyle="admin"
        textWeight="600"
        textSize="body"
        onClick={() => handleSelection(2)}
      >
        <Icon viewBox="0 0 30 36" name="FairnessAge" color="white" m={{ r: '0.5rem' }} size="1rem" />
        AGE
      </Button>
      <Button
        disabled={selected === 3}
        buttonStyle="admin"
        textWeight="600"
        textSize="body"
        onClick={() => handleSelection(3)}
      >
        <Icon viewBox="0 0 33 36" name="FairnessAll" color="white" m={{ r: '0.5rem' }} size="1rem" />
        ALL
      </Button>
    </Div>
  );
}

AirButtonGroup.defaultProps = {
  classifier: false,
};

AirButtonGroup.propTypes = {
  selected: PropTypes.number.isRequired,
  handleSelection: PropTypes.func.isRequired,
  classifier: PropTypes.bool,
};

export function RemediateButton({ disabled, onClick }) {
  return (
    <Button disabled={disabled} buttonStyle="admin" textWeight="600" textSize="body" onClick={onClick}>
      <Icon name="Fairness" size="1rem" viewBox="0 0 37 36" color="white" m={{ r: '.5rem' }} />
      REMEDIATE
    </Button>
  );
}

RemediateButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
